export default __webpack_public_path__ + "static/media/EstadoMexicoLogo.b50c20a2.png";